import './scheduled-task-execution-log.dialog.component.scss'
import {QueuedTaskServiceName, ToastNotificationServiceName} from "../../../utils/names/serviceNames";
import {IHttpResponse} from "angular";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import {QueuedTaskService} from "../../../scheduling_service/service/QueuedTaskService";
import {QueuedTaskExecutionLog} from "../../model/QueuedTaskExecutionLog";
import {Page} from "../../../utils/models/Page";

const DEFAULT_PAGE_SIZE = 10;

export class ScheduledTaskExecutionLogDialog {

    static instance = {
        template: require('./scheduled-task-execution-log.dialog.component.html'),
        controller: [
            '$mdDialog',
            ToastNotificationServiceName,
            QueuedTaskServiceName,
            ScheduledTaskExecutionLogDialog
        ],
        clickOutsideToClose: true,
        bindToController: true,
        controllerAs: '$ctrl',
    };

    private showLoader: boolean;
    private logsPage: Page<QueuedTaskExecutionLog> = {
        number: 1,
        size: DEFAULT_PAGE_SIZE
    };

    constructor(private $mdDialog: angular.material.IDialogService,
                private toastNotificationService: ToastNotificationService,
                private queuedTaskService: QueuedTaskService) {
    }

    $onInit = () => {
        this.pullTaskExecutionLogs();

    };

    pullTaskExecutionLogs = () => {
        this.showLoader = true;
        //I have to substract 1 since HTML page counts from 1,
        //while back-end counts from 0
        let number = this.logsPage.number - 1;
        this.queuedTaskService.pullTaskExecutionLogs(number, this.logsPage.size)
            .then(this.handleLogsPage);
    };

    private handleLogsPage = (resp: IHttpResponse<Page<QueuedTaskExecutionLog>>) => {
        this.showLoader = false;
        if (resp.status === 200) {
            this.logsPage = resp.data;
            //I have to increment since HTML page counts from 1,
            //while back-end counts from 0
            this.logsPage.number++;
        } else {
            this.toastNotificationService.generateErrorMessage('Failed to fetch logs');
        }
    };

    closeDialog = () => {
        this.$mdDialog.hide();
    }

}